<!-- /src/components/common/Card/Card.vue -->
<template>
  <div class="card"
    :class="{'card__small': cardSize == 'small'}"
  >
    <router-link
      :to="{ name: routeToName, params: { sessionType: postType, slug } }"
      class="card__content"
    >
      <div
        class="card__image"
        :style="{ backgroundImage: 'url(' + cardImage + ')' }"
      ></div>
      <div class="card__content__container">
        <div v-if="isMVP"
          class="card__mvp-banner">
          MVP
        </div>

        <div class="card_type__container">
          <i class="card_type icon fas" :class="sessionTypeIcon"></i>
        </div>
        <div class="card__title"
        >
          <h3 v-html="title"></h3>
        </div>
        <div v-if="cardTaxonomyDisplay" class="card__author">
          {{ cardTaxonomyDisplay }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
// import AuthorChip from '@/components/Bio/AuthorChip'
import secondConversions from '@/components/common/utils/filters/secondConversions'
import postMixin from '@/mixins/postMixin'
import _isUndefined from 'lodash/isUndefined'
import { checkNested } from '@/components/common/utils/helpers'

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    cardSize: {
      type: String,
      required: false,
    }
  },

  mixins: [postMixin],

  computed: {
    title() {
      const { post } = this
      const title = checkNested(post, 'title', 'rendered') ? post.title.rendered : post.post_title
      return title
    },
  },


  // components: {
  //   AuthorChip,
  // },

  filters: {
    ...secondConversions,
  },
}
</script>

<style scoped>
.card {
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-shadow: 0 0 1rem rgba(154, 162, 178, 0);
  transition: box-shadow 0.5s ease, transform 0.5s ease;
  border-radius: 4px;
  /* overflow: hidden; */
  will-change: box-shadow, transform;

  &__small {
      font-size: .8em;
  }

  &:hover {
    box-shadow: 0 0.5rem 1rem rgba(154, 162, 178, 0.5);
    transform: translateY(-5px);

    .card__bottom {
      background-color: var(--brandAccent);
    }
  }

  @media (--tablet) {
    margin-bottom: 0;
  }

  &__text {
    margin-left: 0.5rem;
    line-height: 1;
  }

  &__image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    padding-top: 42.15%;
    border-radius: 4px 4px 0 0;
  }

  &__content {
    flex: 1;
    /* padding: 1.5rem; */
    cursor: pointer;

    &__container {
      padding: 0 1rem 0.75rem 1rem;
    }
  }

  &__footer {
    transition: 0.5s background-color;
    background-color: var(--mediumGray);
  }

  &_type {
    &.icon {
      color: white;
      text-align: center;
      background-color: var(--brandAccent);
      border-radius: 50%;
      padding: 0.5em;
      width: 2em;
      height: 2em;
      position: relative;
      margin-top: -1em;

      &:before {
        position: absolute;
        left: 50%;
        top: 50%;

        transform: translate(-50%, -50%);
      }

      &.fa-play {
        &:before {
          left: 55%;
        }
      }
    }

    &__container {
      display: grid;
      justify-content: end;
    }
  }

  &__title {
    color: var(--brandPrimary);
    line-height: 1.1;
    font-size: 0.9em;
    letter-spacing: -0.05em;
    font-weight: 500;

    h3 {
      font-weight: var(--fontWeightBold);
      margin: 0;
      /* max-width: 100%; */

      @media (--desktop-large) {
        /* font-size: 1.4rem; */
      }
    }
  }

  &__date,
  &__duration {
    font-size: 0.7em;
    vertical-align: middle;
  }

  &__author {
    margin: 0.25rem 0 0 0;
    color: var(--brandAccent);
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.75em;
    line-height: 1.1;
  }

  &__tags {
    font-size: 0.6rem;
    display: inline-flex;
    flex-wrap: wrap;
    margin-bottom: 0;

    &__tag {
      display: inline;
      margin-right: 0.45em;
      font-weight: 500;

      &:after {
        content: ',';
      }

      &:last-child {
        margin-right: 0;

        &:after {
          content: '';
        }
      }
    }
  }

  &__actions {
    padding: 0.75rem 1rem;
    font-size: 0.5em;
    font-weight: var(--fontWeightSemibold);
    text-align: center;

    &__item {
      width: 100%;
      font-size: 1.2em;
      margin-bottom: 0.5em;

      &:last-child {
        margin-bottom: 0;
      }

      &--progress {
        color: var(--lightGray);
        text-transform: uppercase;
        font-weight: var(--fontWeightBold);
        letter-spacing: -0.03em;
      }
    }
  }

  &__mvp-banner {
    position: absolute;
    top: -.3rem;
    right: -.5rem;
    background-color: var(--brandAccent);
    border-radius: 4px 4px 0 4px;
    padding: .2rem .5rem .2rem .5rem;
    color: white;
    font-size: .6rem;
    z-index: 3;
    font-weight: 800;

    &::after {
      content: "";
      background-color: #ac5412;
      width: .5rem;
      height: .5rem;
      bottom: -.5rem;
      right: 0;
      z-index: 5;
      position: absolute;
      letter-spacing: .03rem;
      clip-path: polygon(0% 0%, 100% 0%, 0% 100%)
    }
  }

}
</style>
